'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var input = require('./input.js');
var react = require('@chakra-ui/react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var baseStyle = _objectSpread(_objectSpread({}, input["default"].baseStyle.field), {}, {
  minHeight: '80px',
  lineHeight: 'short',
  verticalAlign: 'top'
});
var variants = {
  "default": react.defineStyle(function (props) {
    return input["default"].variants["default"](props).field;
  }),
  floating: react.defineStyle(function (props) {
    return input["default"].variants.floating(props).field;
  })
};
var sizes = {
  xs: _objectSpread(_objectSpread({}, input["default"].sizes.xs.field), {}, {
    py: input["default"].sizes.xs.field.px
  }),
  sm: _objectSpread(_objectSpread({}, input["default"].sizes.sm.field), {}, {
    py: input["default"].sizes.sm.field.px
  }),
  md: _objectSpread(_objectSpread({}, input["default"].sizes.md.field), {}, {
    py: input["default"].sizes.md.field.px
  }),
  lg: _objectSpread(_objectSpread({}, input["default"].sizes.lg.field), {}, {
    py: input["default"].sizes.lg.field.px
  })
};
var defaultProps = {
  size: 'md',
  variant: 'default'
};
var Textarea = {
  baseStyle: baseStyle,
  sizes: sizes,
  variants: variants,
  defaultProps: defaultProps
};
exports["default"] = Textarea;